function getResizedCanvas(canvas,newWidth,newHeight, {
  sw,
  sh,
  sy = 0,
  sx = 0
} = {}) {
  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = newWidth;
  tmpCanvas.height = newHeight;

  var ctx = tmpCanvas.getContext('2d');
  ctx.drawImage(canvas,sx,sy, sw || canvas.width, sh || canvas.height,0,0,newWidth,newHeight);

  return tmpCanvas;
}

function getImage (src, width, height) {
  let image = new Image();
  image.src = src;
  // image.width = width;
  // image.height = height;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      resolve(image)
    }
    image.onerror = (err) => {
      image;
      reject(err)
    }
  })
}

export default async function ({
  blob,
  width,
  height,
  sx = 0,
  sy = 0,
  sw,
  sh
} = {}) {
  let src = window.URL.createObjectURL(blob || new Blob());
  let image
  try {
    image = await getImage(src, width, height);
  } catch (err) {
    image = err.target;
  }
  let newCanvas = getResizedCanvas(image, width, height, {
    sx,
    sy,
    sw,
    sh
  });
  return new Promise((resolve, reject) => {
    newCanvas.toBlob((blob) => {
      resolve(blob);
    })
  })
}



// WEBPACK FOOTER //
// ./src/plugins/setBlobImageSize.js